module.exports = __webpack_public_path__ + "static/media/workEndframe.6e0975e0.png";